import createElement from '../createElement';
export default function PickerItem(props) {
  var color = props.color,
      label = props.label,
      testID = props.testID,
      value = props.value;
  var style = {
    color: color
  };
  return createElement('option', {
    style: style,
    testID: testID,
    value: value
  }, label);
}